<div>
    <div class="cmn-flex row space-between">
        <mat-form-field class="flex">
            <mat-placeholder>Name</mat-placeholder>
            <input [(ngModel)]="contactType.contact_type" matInput required maxlength="20">
        </mat-form-field>
    </div>
    <div class="cmn-flex row space-between">
        <mat-form-field class="flex">
            <mat-placeholder>Description</mat-placeholder>
            <input [(ngModel)]="contactType.description" matInput>
        </mat-form-field>
    </div>
    <mat-checkbox [(ngModel)]="contactType.admin_only">Admin only</mat-checkbox>
</div>
<mat-dialog-actions class="cmn-flex row space-between">
    <button [mat-dialog-close]="this.contactType" color="primary" mat-raised-button>Save</button>
    <button [mat-dialog-close]="false" color="primary" mat-raised-button>Cancel</button>
</mat-dialog-actions>
